import React from 'react';
import { once } from 'lodash';

// @ts-ignore
import AdminSchoolSisSyncHeader from 'admin/components/AdminSchoolSisSyncHeader';
import EventTracking from 'lib/EventTracking';
import Image from 'components/Image';

type Props = {
  orgUuid: string;
  subtext: React.ReactNode;
};

export default class AdminSisSyncPausedView extends React.Component<Props> {
  trackView = once(() => {
    EventTracking.view('rostering.sis_dash.paused.viewed', {
      organization_uud: this.props.orgUuid,
    });
  });

  componentDidMount() {
    this.trackView();
  }

  render() {
    return (
      <section className="AdminSisSyncPausedView">
        <AdminSchoolSisSyncHeader subtext={this.props.subtext} status="paused" />
        <Image src={require('assets/images/admin/AdminSisSyncProcessingView/banner.svg')} />
      </section>
    );
  }
}
